export default function(){
  var popup = jQuery('#mod-region-confirm');
  if(popup.length < 1) return;
  popup = popup[0];
  var btn = jQuery(popup).find('.btn[data-result]');

  jQuery(btn).click(function(){

    if(this.dataset.result === 'yes'){
      var ds = popup.dataset;
      var prevRegion = ds.currentRegion;
      var nextRegion = ds.geoRegion;
      var nextSubdomain = ds.geoSubdomain;

      if(prevRegion !== nextRegion){
        var host = location.hostname;
        var regExp = new RegExp('([^.]*)\.' + ds.rootHost);
        var match = regExp.exec(host);
        var locSubdomain = match ? match[1] : '';
        var href = nextHref(locSubdomain, nextSubdomain, ds.rootHost);

        jQuery.cookie('js_region_sub_ip', nextRegion, {expires: 30, path: '/'});
        if(href){
          location.href = href;
        }
      }
    }

    jQuery(popup).remove();

  });

  function nextHref(locSubdomain, nextSubdomain, rootHost) {
    if(locSubdomain === nextSubdomain) return;

    var href = location.href;
    var host = location.hostname;
    var rSpb = '';
    var result;

    href = href.replace(location.search, '');

    if(!!nextSubdomain){
      rootHost = '.' + rootHost;
    }else{
      nextSubdomain = '';
      rSpb = href.includes('?') ? '&r=1' : '?r=1';
    }

    result = href.replace(host, nextSubdomain + rootHost) + rSpb;

    return result;
  }

  jQuery(popup).closest('.page__content').prepend(jQuery(popup).detach());
};
